import { render, staticRenderFns } from "./BillingHistoryDetail.vue?vue&type=template&id=65a8ec9f&scoped=true"
import script from "./BillingHistoryDetail.vue?vue&type=script&lang=js"
export * from "./BillingHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./BillingHistoryDetail.vue?vue&type=style&index=0&id=65a8ec9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a8ec9f",
  null
  
)

export default component.exports